import NewsletterFourteenContainer from "./containers/NewsletterFourteenContainer";
export default NewsletterFourteenContainer;
